import React from 'react';
import NewsList from './NewsList';

export default ()=>{
     return (
        <div className="sq_main_left">
            <NewsList key={2} type={2} />
            <NewsList key={3} type={3} />
        </div>)
}